import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const companyService = {
    getAllCompany,
    createCompany,
    getCompany,
    updateCompany,
    updateCompanyStatus,
};

const MODULE = {
    COMPANY: 'group-companies',
}

const API_URL = API.BASE_URL + '/v1';

export async function getAllCompany(filter) {
    const requestOptions = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    if (filter?.group) requestOptions.params.group = filter?.group;

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            requestOptions.params[searchParam] = word;
        }
    });
    return await apiHelper(API_URL).get(`/${MODULE.COMPANY}`, requestOptions);
}

export async function createCompany(data) {
    const formData = new FormData();
    formData.append(`group_uuid`, data.group);
    formData.append(`name`, data.name);
    formData.append(`display_name`, data.displayName);
    formData.append(`budget`, data.budget);
    formData.append(`start_operate_time`, data.startTime);
    formData.append(`close_operate_time`, data.endTime);
    formData.append(`operate_description`, data.operateDescription);
    formData.append(`is_private`, data.visibleToEveryone);
    formData.append(`group_uuid`, data.group);
    formData.append(`website_url`, data.website);
    formData.append(`website_annual_report_url`, data.annualReportWebsite);
    if(data.hashtag && data.hashtag.length > 0) {
        data.hashtag.forEach((tag, index) => {
            formData.append(`hashtags[${index}][name]`, tag);
        });
    }
    if (data.image instanceof File) {
        formData.append('image', data.image);
    }
    return apiHelper(API_URL).post(`/${MODULE.COMPANY}`, formData);
}

export async function getCompany(id) {
    return apiHelper(API_URL).get(`/${MODULE.COMPANY}/${id}`);
}

export async function updateCompany(data) {
    const formData = new FormData();
    formData.append(`group_uuid`, data.group);
    formData.append(`name`, data.name);
    formData.append(`display_name`, data.displayName);
    formData.append(`budget`, data.budget);
    formData.append(`start_operate_time`, data.startTime);
    formData.append(`close_operate_time`, data.endTime);
    formData.append(`operate_description`, data.operateDescription);
    formData.append(`is_private`, data.visibleToEveryone);
    formData.append(`group_uuid`, data.group);
    formData.append(`website_url`, data.website);
    formData.append(`website_annual_report_url`, data.annualReportWebsite);
    if(data.hashtag && data.hashtag.length > 0) {
        data.hashtag.forEach((tag, index) => {
            formData.append(`hashtags[${index}][name]`, tag);
        });
    }
    if (data.image instanceof File) {
        formData.append('image', data.image);
    }
    formData.append('_method', "put");
    return apiHelper(API_URL).post(`/${MODULE.COMPANY}/${data.id}`, formData)
}

export async function updateCompanyStatus(data) {
    const requestOptions = {
        is_active: data.isActive,
    }
    return apiHelper(API_URL).patch(`/${MODULE.COMPANY}/${data.id}`, requestOptions);
}